module.exports = __webpack_public_path__ + "img/platzhalter-contact.57ffab85.png";